import React from 'react';
import cn from '../utils/cn';

type KoobCardButtonProps = Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'className'
> & {
  /** Brand border + ring, e.g. the card whose editor is open. */
  selected?: boolean;
  /** Muted, not-allowed look for a locked item; stays clickable (opens a read-only editor). */
  readOnly?: boolean;
};

// A KoobCard-looking surface that is one button: free content, whole card
// clickable (summary tiles that open an editor). For opt-in choices with a
// radio indicator use KoobSelectableCard.
const KoobCardButton = React.forwardRef<HTMLButtonElement, KoobCardButtonProps>(
  (
    { selected = false, readOnly = false, type = 'button', children, ...props },
    ref,
  ) => (
    <button
      ref={ref}
      type={type}
      aria-pressed={selected}
      className={cn(
        'flex w-full min-w-0 flex-col gap-1.5 rounded-lg border border-solid px-3 py-2.5 text-left transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring',
        readOnly
          ? 'cursor-not-allowed bg-gray-50 opacity-75'
          : 'cursor-pointer bg-white shadow-sm',
        selected
          ? 'border-brand ring-2 ring-brand/20'
          : readOnly
            ? 'border-gray-200'
            : 'border-gray-200 hover:border-gray-300',
      )}
      {...props}
    >
      {children}
    </button>
  ),
);

KoobCardButton.displayName = 'KoobCardButton';

export default KoobCardButton;
